import type { BasicCustomMailOptionalItemOverrideInput, LangCode } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { QuestionEmailTemplateItem } from "../_shared/components/email-template-item";

import type { ProductPlanFormModel } from "../../../../../../model";

type Props = {
	isEdited: boolean;
	hasError: boolean;
	// チェックイン7日前
	atCheckInBefore_07days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	onSetAtCheckInBefore_07daysForText: (value: string) => void;
	onSetAtCheckInBefore_07daysForOverride: (value: boolean) => void;
	onSetAtCheckInBefore_07daysForShouldSendMail: (value: boolean) => void;
	handleClickedSendTestEmailReservationAtCheckInBefore_07days: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;
	basicAtCheckInBefore_07daysText?: string;
	// チェックイン1日前
	atCheckInBefore_01days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	onSetAtCheckInBefore_01daysForText: (value: string) => void;
	onSetAtCheckInBefore_01daysForOverride: (value: boolean) => void;
	onSetAtCheckInBefore_01daysForShouldSendMail: (value: boolean) => void;
	handleClickedSendTestEmailReservationAtCheckInBefore_01days: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;
	basicAtCheckInBefore_01daysText?: string;
	// チェックイン当日
	atCheckInBefore_00days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	onSetAtCheckInBefore_00daysForText: (value: string) => void;
	onSetAtCheckInBefore_00daysForOverride: (value: boolean) => void;
	onSetAtCheckInBefore_00daysForShouldSendMail: (value: boolean) => void;
	handleClickedSendTestEmailReservationAtCheckInBefore_00days: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;
	basicAtCheckInBefore_00daysText?: string;
	//
	hotelEmailAddress: string;
	lang: LangCode;
	title?: string;
	guide?: string;
	/** 基本メール設定の文言 */
	basicCustomMailSetting: ProductPlanFormModel["QueryData"]["basicCustomMailSetting"];
};

export const ForCheckInEmailTemplates = ({
	isEdited,
	hasError,
	atCheckInBefore_07days,
	onSetAtCheckInBefore_07daysForText,
	onSetAtCheckInBefore_07daysForOverride,
	onSetAtCheckInBefore_07daysForShouldSendMail,
	atCheckInBefore_01days,
	onSetAtCheckInBefore_01daysForText,
	onSetAtCheckInBefore_01daysForOverride,
	onSetAtCheckInBefore_01daysForShouldSendMail,
	atCheckInBefore_00days,
	onSetAtCheckInBefore_00daysForText,
	onSetAtCheckInBefore_00daysForOverride,
	onSetAtCheckInBefore_00daysForShouldSendMail,
	hotelEmailAddress,

	lang,
	handleClickedSendTestEmailReservationAtCheckInBefore_00days,
	handleClickedSendTestEmailReservationAtCheckInBefore_01days,
	handleClickedSendTestEmailReservationAtCheckInBefore_07days,

	title: _title,
	guide: _guide,
	basicCustomMailSetting,
}: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title=""
			guide=""
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="space-y-6">
					<QuestionEmailTemplateItem
						lang={lang}
						label={"1週間前"}
						dialogTitle={"チェックイン1週間前"}
						textValue={atCheckInBefore_07days?.text.value}
						isOverride={atCheckInBefore_07days?.override.value}
						shouldSendEmail={atCheckInBefore_07days?.shouldSendEmail.value}
						textErrorMessage={atCheckInBefore_07days?.text.error}
						overrideErrorMessage={atCheckInBefore_07days?.override.error}
						shouldSendEmailErrorMessage={atCheckInBefore_07days?.shouldSendEmail.error}
						handleChangeText={onSetAtCheckInBefore_07daysForText}
						handleChangeOverride={onSetAtCheckInBefore_07daysForOverride}
						handleChangeShouldSendEmail={onSetAtCheckInBefore_07daysForShouldSendMail}
						sendTestEmail={handleClickedSendTestEmailReservationAtCheckInBefore_07days}
						hotelEmailAddress={hotelEmailAddress}
						overrideMode={atCheckInBefore_07days?.override.value}
						onOverrideModeChange={onSetAtCheckInBefore_07daysForOverride}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckInBefore_07days}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"前日"}
						dialogTitle="チェックイン前日"
						textValue={atCheckInBefore_01days?.text.value}
						isOverride={atCheckInBefore_01days?.override.value}
						shouldSendEmail={atCheckInBefore_01days?.shouldSendEmail.value}
						textErrorMessage={atCheckInBefore_01days?.text.error}
						overrideErrorMessage={atCheckInBefore_01days?.override.error}
						shouldSendEmailErrorMessage={atCheckInBefore_01days?.shouldSendEmail.error}
						handleChangeText={onSetAtCheckInBefore_01daysForText}
						handleChangeOverride={onSetAtCheckInBefore_01daysForOverride}
						handleChangeShouldSendEmail={onSetAtCheckInBefore_01daysForShouldSendMail}
						sendTestEmail={handleClickedSendTestEmailReservationAtCheckInBefore_01days}
						hotelEmailAddress={hotelEmailAddress}
						overrideMode={atCheckInBefore_01days?.override.value}
						onOverrideModeChange={onSetAtCheckInBefore_01daysForOverride}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckInBefore_01days}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"当日"}
						dialogTitle="チェックイン当日"
						textValue={atCheckInBefore_00days?.text.value}
						isOverride={atCheckInBefore_00days?.override.value}
						shouldSendEmail={atCheckInBefore_00days?.shouldSendEmail.value}
						textErrorMessage={atCheckInBefore_00days?.text.error}
						overrideErrorMessage={atCheckInBefore_00days?.override.error}
						shouldSendEmailErrorMessage={atCheckInBefore_00days?.shouldSendEmail.error}
						handleChangeText={onSetAtCheckInBefore_00daysForText}
						handleChangeOverride={onSetAtCheckInBefore_00daysForOverride}
						handleChangeShouldSendEmail={onSetAtCheckInBefore_00daysForShouldSendMail}
						sendTestEmail={handleClickedSendTestEmailReservationAtCheckInBefore_00days}
						hotelEmailAddress={hotelEmailAddress}
						overrideMode={atCheckInBefore_00days?.override.value}
						onOverrideModeChange={onSetAtCheckInBefore_00daysForOverride}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckInBefore_00days}
					/>
				</div>
			}
		/>
	);
};

ForCheckInEmailTemplates.displayName = "ForCheckInEmailTemplates";
